import React, { Component, Children, isValidElement, createElement } from 'react'
import PropTypes from 'prop-types'
import { SortableElement } from 'react-sortable-hoc'
import { TransitionGroup } from 'react-transition-group'
import Grid from '@material-ui/core/Grid'
import Grow from '@material-ui/core/Grow'
import SortableContainer from 'atoms/SortableContainer'

const SortableItem = SortableElement(props => (
  <Grow {...props} />
))

export default class ItemsGrid extends Component {
  static propTypes = {
    wrap: PropTypes.string,
    children: PropTypes.any,
    onSortEnd: PropTypes.func,
    spacing: PropTypes.number,
  }

  static defaultProps = {
    wrap: 'wrap',
    spacing: 8,
  }

  handleSortEnd = (options) => {
    const { onSortEnd } = this.props
    const { oldIndex, newIndex } = options
    if (oldIndex !== newIndex) {
      onSortEnd(options)
    }
  }

  renderChild = (child, index) => {
    if (!isValidElement(child)) return null
    const { onSortEnd } = this.props
    const { disableSorting, ...rest } = child.props
    return (
      <SortableItem
        index={index}
        key={child.key}
        disabled={!onSortEnd || disableSorting}
      >
        <Grid item>
          { createElement(child.type, rest) }
        </Grid>
      </SortableItem>
    )
  }

  render() {
    const { wrap, onSortEnd, children, ...rest } = this.props
    return (
      <SortableContainer
        axis={wrap === 'nowrap' ? 'x' : 'xy'}
        onSortEnd={onSortEnd && this.handleSortEnd}
      >
        <TransitionGroup component={Grid} wrap={wrap} container {...rest}>
          { Children.map(children, this.renderChild) }
        </TransitionGroup>
      </SortableContainer>
    )
  }
}
